export default __webpack_public_path__ + "static/media/A0005.f0a00e9f.png";